import React from "react";
import { Row } from "@hex-insights/core";
import { useActivePageRegistration } from "@hex-insights/router";
import { EmptyView } from "../../../../../../Components/Empty";
import { Icon } from "../../../../../../Components/Icon";
import { StudentDetailQuery } from "../../../../../../Utilities";
import { DetailRouteContext } from "../../RouteContext";

export type ResourcesBodyProps = {
	student: StudentDetailQuery["student"];
};

export function ResourcesBody(_: ResourcesBodyProps) {
	const { subPageInfos } = React.useContext(DetailRouteContext);
	useActivePageRegistration(subPageInfos.health);

	return (
		<Row justify="spaced-start" style={{ flexGrow: 1 }}>
			<EmptyView IconComponent={Icon.Folder} primaryText="Resources" secondaryText="No resources listed" />
		</Row>
	);
}
